
define('text!templates/progressbar.html',[],function () { return '<div class="progress-bar {{loaderClass}}" id="{{uid}}">\n    <div class="bar">\n        <div class="colored-bar" style="width:{{percent}}%" class="value"></div>\n    </div>\n</div>';});

